import OrderSchoolGroupItem from './OrderSchoolGroupItem.component';

export default OrderSchoolGroupItem;